import { createStore, combineReducers, applyMiddleware } from "redux";
//import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import thunk from "redux-thunk";
import { connectRouter } from "connected-react-router";
import { createBrowserHistory } from "history";
import { userReducer } from "./user";
import { trialReducer } from "./trial";
import { dataReducer } from "./data";
import { blogReducer } from "./blogs";

import logger from "redux-logger";

export const history = createBrowserHistory();

const reducers = combineReducers({
  router: connectRouter(history),
  user: userReducer,
  trial: trialReducer,
  data: dataReducer,
  blogs: blogReducer
});

const middlewareEnhancer = applyMiddleware(thunk, logger);
//const enhancers = [middlewareEnhancer];
//const composedEnhancers = composeWithDevTools(...enhancers);

const store = createStore(reducers, {}, middlewareEnhancer);

export default store;
